import { useContext } from 'react';
import { StatePlateDefaults } from '../sections/statePlateDefaults/StatePlateDefaults';
import { AuthContext } from '../../../Context/AuthContext';
import { useAdminToast } from '../shell/AdminToastContext';

export const DireccionPlacasPage = () => {
    const toast = useAdminToast();
    const { logout } = useContext(AuthContext);
    return <StatePlateDefaults toast={toast} logout={logout} />;
};

export default DireccionPlacasPage;
